import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Check if we're on a legal page
  const isLegalPage = ['/privacy-policy', '/terms-of-service', '/security-architecture'].includes(location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const scrollToSection = (sectionId) => {
    // If we're not on home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // If already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const goHome = () => {
    navigate('/');
    // Scroll to top when going home
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    }, 50);
  };

  const headerClass = isLegalPage 
    ? 'bg-slate-900 shadow-lg' 
    : `transition-all duration-300 ${isScrolled ? 'bg-slate-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`;

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 ${headerClass}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <button
              onClick={goHome}
              className="hover:opacity-80 transition-opacity duration-200"
              aria-label="Go to homepage"
            >
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752097997411-Namvoro-Light-logo.png"
                alt="Namvoro - Digital Brand Management"
                className="h-8 w-auto"
              />
            </button>
          </div>

          <nav className="hidden md:flex space-x-8">
            <button
              onClick={goHome}
              className="text-white hover:text-emerald-400 transition-colors duration-200 font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-emerald-400 transition-colors duration-200 font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('infrastructure')}
              className="text-white hover:text-emerald-400 transition-colors duration-200 font-medium"
            >
              Infrastructure
            </button>
            <button
              onClick={() => scrollToSection('why-namvoro')}
              className="text-white hover:text-emerald-400 transition-colors duration-200 font-medium"
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection('consultation')}
              className="bg-emerald-600 text-white px-4 py-2 rounded-lg hover:bg-emerald-700 transition-colors duration-200 font-medium"
            >
              Get Started
            </button>
          </nav>

          {/* Mobile menu button - for future implementation */}
          <div className="md:hidden">
            <button
              onClick={goHome}
              className="text-white hover:text-emerald-400 transition-colors duration-200 font-medium text-sm"
            >
              Home
            </button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;